
<template>
  <div>
    <mdb-modal centered @close="$store.commit('clearCurrentModal')" elegant size="lg">
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue">{{ options.title }}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="d-flex flex-column pt-0">
        <h3 class="isi-sub-heading-gray mb-3">
          Separate Meeting Room
          <span>&minus; At least one room that can be used as a separate meeting room.</span>
        </h3>
        <h3 class="isi-sub-heading-gray mb-3">
          Barrier-free Access
          <span>&minus; The facility is set up with barrier-free access. For example, wheelchair accessible rooms and/or corridors with ground level elevator and extra wide doors.</span>
        </h3>
        <h3 class="isi-sub-heading-gray mb-3">
          Shelf Test Room
          <span>&minus; At least one test room with a variable shelf that can be used for shelf tests.</span>
        </h3>
        <h3 class="isi-sub-heading-gray mb-3">
          Very Large Test Room
          <span>&minus; At least one multipurpose test room of at least 25 square meters clear space.</span>
        </h3>
        <h3 class="isi-sub-heading-gray mb-3">
          Backup Electricity
          <span>&minus; The facility is equipped with a generator for backup electricity.</span>
        </h3>
        <h3 class="isi-sub-heading-gray mb-3">
          Catering Option
          <span>&minus; Access to catering options for clients and respondents.</span>
        </h3>
        <mdb-btn
          class="btn btn-isi align-self-center"
          @click.native="$store.commit('clearCurrentModal')"
        >Ok</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
</style>